package org.vreo.devicehub.features.liveAccess.presentation

import org.vreo.devicehub.features.core.presentation.UiText
import org.vreo.devicehub.features.liveAccess.domain.WebRtcConnectMode

/**
 * Live access state
 */
data class LiveAccessState(
    val isLoading: Boolean = false,
    val error: UiText? = null,
    val isDeviceActive: Boolean = false,

    val connectionModeIndex: Int = WebRtcConnectMode.NORMAL.ordinal,
    val connected: Boolean = false,
    val liveViewEnabled: Boolean = false,
)